var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-sm-6 col-lg-6 offset-lg-1 footer--paymentMode"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('footer.payment_mode')))]), _vm._v(" "), _c('ul', _vm._l(_vm.content.payment_mode, function (link, index) {
    return _c('li', {
      key: index,
      class: "payment-".concat(link).concat(_vm.setLanguage(link))
    }, [_c('mdm-icon', {
      class: "icon icon-item ".concat(link).concat(_vm.setLanguage(link)),
      attrs: {
        "original": true,
        "name": "".concat(link).concat(_vm.setLanguage(link)),
        "role": "presentation",
        "aria-hidden": "true"
      }
    })], 1);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };